export const DOCUMENT_SECTIONS = [
  "SHIPPING DOCUMENTS",
  "PERMIT & LICENSES",
  "CUSTOMS CLEARANCE",
  "SHIPPINGLINE FORMALITIES & DELIVERY",
];
